



















import { Component, Watch, Mixins, Prop } from 'vue-property-decorator';
import { LoadingState } from '@/entities/LoadingState';
import BaseMixin from '../../mixins/BaseMixin';
import { CarPartsModuleTypes } from '@/store/modules/car-parts';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import PartListItem from '@/components/part-search/PartListItem.vue';

@Component({
    components: {
        PartListItem,
    },
})
export default class RandomPartsList extends Mixins(BaseMixin) {
    @Prop(String)
    private carTitle!: string;
    @Prop(String)
    private partActionLink!: string;

    private numberOfItems: number = 2;
    private randomParts: PartSearchResultDetails[] = [];

    public get partsOfCar(): PartSearchResultDetails[] {
        return this.$store.getters[CarPartsModuleTypes.getters.parts];
    }

    public get loadingState(): LoadingState {
        return this.$store.getters[CarPartsModuleTypes.getters.carPartsLoadingState];
    }

    @Watch('loadingState')
    private onLoadingStateChanged(): void {
        if (this.loadingState !== LoadingState.Loaded || this.partsOfCar.length === 0) {
            return;
        }

        let parts = this.partsOfCar;
        for (let i = 0; i < this.numberOfItems; i++) {
            if (parts.length === 0) {
                break;
            }
            const randomIndex = this.getRandomInt(0, parts.length - 1);
            const partToAdd = parts[randomIndex];
            this.randomParts.push(partToAdd);
            parts = parts.filter((p) => p !== partToAdd);
        }
    }

    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     */
    private getRandomInt(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
